import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import TabNavigation from '../components/TabNavigation';
import ExperienceContent from '../components/ExperienceContent';
import PricingTable from '../components/PricingTable';

const Experience = () => {
  const [activeTab, setActiveTab] = useState('nge');

  const tabs = [
    { id: 'nge', label: 'Naughty GFE' },
    { id: 'gfe', label: 'Sweet GFE' }
  ];

  const ngePricing = {
    incallRates: [
      { duration: '1 Hour', price: '$900' },
      { duration: '1.5 Hours', price: '$1,350' },
      { duration: '2 Hours', price: '$1,800' },
      { duration: '3 Hours (My Fave)', price: '$2,700' }
    ],
    outcallRates: [
      { duration: '1 Hour', price: '$1,100' },
      { duration: '1.5 Hours', price: '$1,600' },
      { duration: '2 Hours', price: '$2,200' },
      { duration: '3 Hours (My Fave)', price: '$3,300' }
    ],
    extendedRates: [
      { duration: 'Dinner and Dessert (4hrs)', price: '$2,800 Incall / $3,000 Outcall' },
      { duration: 'A saucy sleepover (12hrs)', price: '$6,000 (AUD)' },
      { duration: 'A day of bliss (24hrs)', price: '$9,000 (AUD)' },
      { duration: 'Why not make it a weekend? (additional 24hrs)', price: '$8,000 (AUD)' }
    ]
  };

  const gfePricing = {
    incallRates: [
      { duration: '1 Hour', price: '$700' },
      { duration: '1.5 Hours', price: '$1,000' },
      { duration: '2 Hours', price: '$1,400' },
      { duration: '3 Hours (My Fave)', price: '$2,100' }
    ],
    outcallRates: [
      { duration: '1 Hour', price: '$900' },
      { duration: '1.5 Hours', price: '$1,350' },
      { duration: '2 Hours', price: '$1,800' },
      { duration: '3 Hours (My Fave)', price: '$2,700' }
    ],
    extendedRates: [
      { duration: 'Dinner and Dessert (4hrs)', price: '$2,200 Incall / $2,600 Outcall' },
      { duration: 'A romantic sleepover (12hrs)', price: '$5,200 (AUD)' },
      { duration: 'A day of bliss (24hrs)', price: '$7,800 (AUD)' },
      { duration: 'Why not make it a weekend? (additional 24hrs)', price: '$6,800 (AUD)' }
    ]
  };

  const depositInfo = {
    message: "All bookings require a 30% non-refundable deposit. You can reschedule once with 48 hours' notice.",
    details: "My preferred deposit method as it's the most discreet. It's a free, instant, anonymous app supported by the big four Australian banks. If Beem isn't an option for you, I also offer USDT (tron), gift card, and international-friendly options."
  };

  return (
    <div>
      {/* Page Header */}
      <section className="section-padding" style={{ paddingBottom: '40px' }}>
        <div className="container">
          <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
            <h1 className="hero-large" style={{ marginBottom: '24px' }}>
              Experiences
            </h1>
            <p className="body-large" style={{ lineHeight: '1.8', color: 'var(--text-secondary)' }}>
              Each experience is intentional, immersive, and entirely yours.
            </p>
          </div>
        </div>
      </section>

      {/* Tab Navigation */}
      <section style={{ padding: '0 40px 40px' }}>
        <div className="container">
          <TabNavigation 
            tabs={tabs} 
            activeTab={activeTab} 
            onTabSelect={setActiveTab} 
          />
        </div>
      </section>

      {/* Content Area */}
      <section style={{ padding: '0 40px 80px' }}>
        <div className="container">
          {activeTab === 'nge' && (
            <ExperienceContent
              title="Naughty GFE"
              description="Bold. Unfiltered. Electric. This is the experience for those who know exactly what they want and aren't afraid to ask for it. More physical, more charged, more passionate at every turn."
              details="The Naughty GFE is where inhibitions fall away and desire takes the lead. Expect intensity, exploration, and a level of indulgence that's unapologetically immersive. I bring confidence, creativity, and a hunger that matches yours."
              imageSrc="https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/h39u0qsh_Honey%20Sofia%20-%201387-Edit-face%20blur.jpg"
              pricing={<PricingTable {...ngePricing} />}
              depositInfo={depositInfo}
            />
          )}

          {activeTab === 'gfe' && (
            <ExperienceContent
              title="Sweet GFE"
              description="This is where ease meets intimacy. Soft conversation over wine. Lingering touches that feel natural, not performative. The warmth of being truly present with someone who sees you — and wants to be seen in return."
              details="The Sweet GFE is for those who crave connection as much as chemistry. Whether we're sharing dinner, stealing kisses between courses, or losing track of time tangled up in each other, every moment feels unrushed, intuitive, and deeply satisfying."
              imageSrc="https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/5u1exlyr_Honey%20Sofia%20-%200350-Edit-face%20blur.jpg"
              pricing={<PricingTable {...gfePricing} />}
              depositInfo={depositInfo}
            />
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section style={{ padding: '80px 40px', background: 'var(--bg-subtle)', textAlign: 'center' }}>
        <div className="container">
          <div style={{ maxWidth: '700px', margin: '0 auto' }}>
            <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
              Ready to book?
            </h2>
            <p className="body-large" style={{ marginBottom: '32px', lineHeight: '1.8', color: 'var(--text-secondary)' }}>
              Share a little about yourself, what you're looking for, and your preferred dates. I'll respond within 24 hours to confirm availability.
            </p>
            <Link 
              to="/bookings" 
              className="btn-primary"
              style={{
                background: 'var(--burgundy)',
                color: '#fff',
                border: '2px solid var(--burgundy)',
                fontWeight: '700',
                letterSpacing: '1px'
              }}
            >
              Enquire Now
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Experience;
